import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoLocked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M23 12v4H13v-4a5 5 0 0 1 10 0m-12 4v-4a7 7 0 1 1 14 0v4.01c1.065.038 1.532.187 2.003.435.552.29.984.717 1.28 1.26.294.544.451 1.082.451 2.568v6.454c0 1.486-.157 2.024-.452 2.568-.295.543-.727.97-1.28 1.26-.55.29-1.098.445-2.607.445H11.074c-1.508 0-2.056-.155-2.607-.445a3.05 3.05 0 0 1-1.28-1.26c-.295-.544-.452-1.082-.452-2.568v-6.454c0-1.486.157-2.024.452-2.568a3.05 3.05 0 0 1 1.28-1.26c.542-.285 1.08-.44 2.534-.445",
		clipRule: "evenodd"
	})
});
export default SvgIcoLocked;
